import { HeartPulse } from 'lucide-react'
import { SeriesChart, VitalChartFrame, vitalNumber } from '../VitalPlot/VitalPlot'
import '../VitalPlot/VitalPlot.css'
import './PressureChart.css'

function finite(value) {
  return vitalNumber(value)
}

function pairLabel(systolic, diastolic) {
  const sys = systolic == null ? '—' : Math.round(systolic)
  const dia = diastolic == null ? '—' : Math.round(diastolic)
  return `${sys}/${dia}`
}

function PressureChart({ points = [] }) {
  const rows = points.filter((point) => finite(point.systolic) != null || finite(point.diastolic) != null)
  const series = rows.map((point) => {
    const systolic = finite(point.systolic)
    const diastolic = finite(point.diastolic)
    return { at: point.at, value: systolic, label: pairLabel(systolic, diastolic) }
  })
  const secondary = rows.map((point) => ({ at: point.at, value: finite(point.diastolic) }))
  const latest = [...rows].reverse().find((point) => finite(point.systolic) != null || finite(point.diastolic) != null)
  const values = rows.flatMap((point) => [finite(point.systolic), finite(point.diastolic)]).filter((value) => value != null)
  const dataMin = values.length ? Math.min(...values) : 80
  const dataMax = values.length ? Math.max(...values) : 140
  const yMin = Math.min(60, Math.floor(dataMin / 20) * 20)
  const yMax = Math.max(160, Math.ceil(Math.max(dataMax, 140) / 20) * 20)
  const ticks = []
  for (let tick = yMin; tick <= yMax; tick += 20) ticks.push(tick)

  return (
    <VitalChartFrame
      className="pressure-chart"
      icon={<HeartPulse size={16} />}
      title="Pressão Arterial (mmHg)"
      badgeLabel="PA Atual:"
      badgeValue={latest ? pairLabel(finite(latest.systolic), finite(latest.diastolic)) : '—'}
      legend={[
        { mark: 'is-sys', label: 'Sistólica' },
        { mark: 'is-dia', label: 'Diastólica' },
        { mark: 'is-alert', label: 'Limiar (≥ 140 mmHg)' },
        { mark: 'is-safe', label: 'Hipotensão (< 90 mmHg)' }
      ]}
      empty={series.length === 0 ? 'Nenhuma pressão registrada para este paciente.' : ''}
    >
      <SeriesChart
        points={series}
        secondary={secondary}
        yMin={yMin}
        yMax={yMax}
        ticks={ticks}
        tickLabel={(tick) => String(tick)}
        guides={[
          { key: 'high', value: 140, className: 'vital-guide-alert' },
          { key: 'low', value: 90, className: 'vital-guide-safe' }
        ]}
        gradientFrom="#7c3aed"
        gradientTo="#ddd6fe"
        secondaryStroke="#6366f1"
        showArea={false}
        ariaLabel="Pressão arterial sistólica e diastólica"
      />
    </VitalChartFrame>
  )
}

export default PressureChart
